/* ================================================================
   BRITTEN CUSTOM: Wedding landing pages — behaviour
   Location: assets/britten-wedding-landing.js
   Called from: templates/page.wedding-landing.liquid

   Fade-up images (matches The Picture Desk's tile-loading signature) and
   GA4 events for the generated .bwl article. PRIMARY analytics path is
   window.Shopify.analytics.publish — GA4 on this store runs inside
   Shopify's web-pixel sandbox, so window.gtag/window.dataLayer do not
   exist on the live page. A custom pixel in admin (see docs/veil-guide-
   custom-pixel.md) subscribes to these britten_ event names and forwards
   them to GA4. gtag/dataLayer are kept as a harmless SECONDARY path only.
   All inside try/catch so analytics can never break the page.
   ================================================================ */
(function () {
  'use strict';

  // === CONFIGURATION ===
  var FEATURE_ENABLED = true;
  var DEBUG_MODE = false;
  var EVENT_PREFIX = 'britten_';

  function log(msg) {
    if (DEBUG_MODE) console.log('[Britten Wedding Landing] ' + msg);
  }

  if (!FEATURE_ENABLED) return;

  var root = document.querySelector('.bwl[data-landing]');
  if (!root) return;

  function send(name, data) {
    var payload = data || {};
    try {
      payload.viewport = window.innerWidth <= 798 ? 'mobile' : 'desktop';
    } catch (e) { /* ignore */ }
    var eventName = EVENT_PREFIX + name;
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(eventName, payload);
      }
    } catch (e) { /* analytics must never break the page */ }
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, payload);
      } else if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push({ event: eventName, britten: payload });
      }
    } catch (e) { /* analytics must never break the page */ }
  }

  var landing = root.getAttribute('data-landing') || root.getAttribute('data-key') || '';
  var kind = root.getAttribute('data-kind') || '';

  // ---------------------------------------------------------------
  // Move "Weddings in this palette" / "Veils these brides wore" / the FAQ
  // ("Questions brides ask") / "More real weddings" below the embedded
  // Picture Desk wall, per the
  // 4a layout: the wall must come directly after the header. The
  // CURRENT generator still emits these sections (plus the 24-tile
  // `.bwl-grid`, hidden separately once the wall renders — see
  // hideStaticSeoGridOnce in britten-picture-desk.js) between the header
  // and the wall, which pushed the wall ~3,000px down the page. They stay
  // in the HTML (crawlers, and a visitor with JS off still gets them,
  // just lower down) — this only ever MOVES existing nodes, never removes
  // them. Runs once, synchronously, since `.bpd` is present in the raw
  // HTML the moment the page parses (rendered by the same Liquid template,
  // not created by picture-desk.js) — no need to wait for that script.
  //
  // "Weddings in this palette" is also collapsed to the first 12 with a
  // "Show all N weddings" button (see collapseWeddingsList): the
  // generator's list can run to 50+ entries, which is a lot of text to
  // scroll past between the wall and the veils/related sections below it.
  // ---------------------------------------------------------------
  function moveContentBelowWall() {
    var wall = document.querySelector('.bpd');
    if (!wall) return;
    var sections = [
      root.querySelector('.bwl-weddings'),
      root.querySelector('.bwl-veils'),
      root.querySelector('.bwl-faq'),
      root.querySelector('.bwl-related')
    ];
    var insertAfter = wall;
    sections.forEach(function (el) {
      if (!el) return;
      insertAfter.insertAdjacentElement('afterend', el);
      insertAfter = el;
    });
  }

  function collapseWeddingsList(limit) {
    // document, not root: moveContentBelowWall (called first, just above)
    // has already moved this section out of `root` (the `.bwl` article).
    var section = document.querySelector('.bwl-weddings');
    if (!section) return;
    var list = section.querySelector('ul');
    if (!list) return;
    var items = Array.prototype.slice.call(list.children);
    var moreP = section.querySelector('.bwl-weddings-more');
    var extra = 0;
    if (moreP) {
      var m = /and\s+(\d+)\s+more/i.exec(moreP.textContent || '');
      if (m) extra = parseInt(m[1], 10) || 0;
    }
    if (items.length <= limit && !extra) return;
    var total = items.length + extra;
    items.forEach(function (li, i) { li.hidden = i >= limit; });
    if (!moreP) return;
    moreP.textContent = '';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'bwl-weddings-toggle';
    btn.textContent = 'Show all ' + total + ' weddings';
    btn.addEventListener('click', function () {
      items.forEach(function (li) { li.hidden = false; });
      btn.remove();
      if (extra) {
        var note = document.createElement('p');
        note.className = 'bwl-weddings-note';
        note.textContent = 'and ' + extra + ' more — see the wall above for every photograph.';
        moreP.appendChild(note);
      }
      send('landing_weddings_expand', { landing: landing, total: total });
    });
    moreP.appendChild(btn);
  }

  moveContentBelowWall();
  collapseWeddingsList(12);

  // ---------------------------------------------------------------
  // Palette swatch tap (stage 2 header contract: .bwl-swatch[data-hex]) —
  // sorts the embedded Picture Desk wall (mode:'landing', rendered below
  // this article by templates/page.wedding-landing.liquid) to that shade,
  // without a page reload. Waits for the wall's own script to have booted
  // (it exposes root.bpdSortToHex once ready); if it hasn't yet, retries
  // shortly rather than dropping the tap. No-ops entirely if the wall
  // isn't on the page (e.g. this article rendered standalone somewhere).
  // ---------------------------------------------------------------
  function sortWallToHex(hex) {
    var wall = document.querySelector('.bpd');
    if (!wall) return;
    if (typeof wall.bpdSortToHex === 'function') {
      wall.bpdSortToHex(hex);
      return;
    }
    // Picture Desk script loads `defer` and may not have run yet.
    setTimeout(function () {
      if (typeof wall.bpdSortToHex === 'function') wall.bpdSortToHex(hex);
    }, 150);
  }

  root.addEventListener('click', function (e) {
    var swatch = e.target.closest ? e.target.closest('.bwl-swatch[data-hex]') : null;
    if (!swatch) return;
    var hex = swatch.getAttribute('data-hex');
    if (!hex) return;
    sortWallToHex(hex);
    send('landing_palette_click', { landing: landing, hex: hex });
  });

  // ---------------------------------------------------------------
  // Top-fold sell: clone the first 5 weddings and first 5 veils into the
  // header alongside the copy column (1l desktop only — see CSS, hidden
  // under 900px). Built client-side from the existing .bwl-weddings /
  // .bwl-veils lists so the generated contract doesn't need a new block.
  // ---------------------------------------------------------------
  function buildHeadSummaries() {
    var head = root.querySelector('.bwl-head');
    if (!head) return;

    var weddingItems = root.querySelectorAll('.bwl-weddings li');
    var veilLinks = root.querySelectorAll('.bwl-veils li a[data-handle]');
    if (!weddingItems.length && !veilLinks.length) return;

    var wrap = document.createElement('div');
    wrap.className = 'bwl-head__summaries';

    if (weddingItems.length) {
      var wBlock = document.createElement('div');
      wBlock.className = 'bwl-head__summary';
      var wTitle = document.createElement('p');
      wTitle.className = 'bwl-head__summary-title';
      wTitle.textContent = 'Weddings in this palette';
      var wLine = document.createElement('p');
      wLine.className = 'bwl-head__summary-line';
      var parts = [];
      for (var i = 0; i < Math.min(5, weddingItems.length); i++) {
        var a = weddingItems[i].querySelector('a');
        var span = weddingItems[i].querySelector('span');
        var name = a ? a.textContent.replace(/\s+/g, ' ').trim() : '';
        var detail = span ? span.textContent.replace(/\s+/g, ' ').trim() : '';
        if (!name) continue;
        parts.push(detail ? name + ', ' + detail : name);
      }
      wLine.textContent = parts.join(' · ');
      wBlock.appendChild(wTitle);
      wBlock.appendChild(wLine);
      wrap.appendChild(wBlock);
    }

    if (veilLinks.length) {
      var vBlock = document.createElement('div');
      vBlock.className = 'bwl-head__summary';
      var vTitle = document.createElement('p');
      vTitle.className = 'bwl-head__summary-title';
      vTitle.textContent = 'Veils these brides wore';
      var vLine = document.createElement('p');
      vLine.className = 'bwl-head__summary-line';
      for (var j = 0; j < Math.min(5, veilLinks.length); j++) {
        if (j > 0) vLine.appendChild(document.createTextNode(' · '));
        var link = veilLinks[j].cloneNode(true);
        link.className = 'bwl-head__summary-link';
        vLine.appendChild(link);
      }
      vBlock.appendChild(vTitle);
      vBlock.appendChild(vLine);
      wrap.appendChild(vBlock);
    }

    head.appendChild(wrap);
  }
  buildHeadSummaries();

  // ---------------------------------------------------------------
  // Fade-up tile images (400ms, same as The Picture Desk)
  // ---------------------------------------------------------------
  function wireImage(img) {
    if (!img || img.classList.contains('bwl-tile__img--in')) return;
    function reveal() { img.classList.add('bwl-tile__img--in'); }
    if (img.complete && img.naturalWidth > 0) {
      reveal();
    } else {
      img.addEventListener('load', reveal, { once: true });
      img.addEventListener('error', reveal, { once: true });
    }
  }
  var tileImgs = root.querySelectorAll('.bwl-tile img');
  for (var i = 0; i < tileImgs.length; i++) wireImage(tileImgs[i]);

  // ---------------------------------------------------------------
  // Events
  // ---------------------------------------------------------------
  send('landing_view', { landing: landing, kind: kind });

  root.addEventListener('click', function (e) {
    var tile = e.target.closest ? e.target.closest('.bwl-tile[data-id]') : null;
    if (tile) {
      send('landing_photo_click', { landing: landing, photo_id: tile.getAttribute('data-id') || '' });
      return;
    }

    var veilLink = e.target.closest ? e.target.closest('[data-handle]') : null;
    if (veilLink) {
      var productHandle = veilLink.getAttribute('data-handle') || '';
      send('landing_shop_click', { landing: landing, product_handle: productHandle });
      return;
    }

    var relatedLink = e.target.closest ? e.target.closest('.bwl-related a') : null;
    if (relatedLink) {
      send('landing_related_click', { landing: landing, to: relatedLink.getAttribute('href') || '' });
      return;
    }

    var navLink = e.target.closest ? e.target.closest('.bwn a[data-nav-to]') : null;
    if (navLink) {
      send('landing_nav_click', { from: 'landing', to: navLink.getAttribute('data-nav-to') || '' });
    }
  });

  log('boot: landing=' + landing + ' kind=' + kind);
})();
